export class OptionsModel {
    constructor(options) {
        var _a, _b, _c, _d;
        this.environment = 'prod';
        this.environment = options.environment || 'prod';
        this.apiUrl = this.buildApiUrl(options);
        this.configCode = options.configCode.toUpperCase();
        this.siteCode = options.siteCode.toUpperCase();
        this.clientCode = options.clientCode;
        this.resourceUrl = this.buildResourceUrl(options);
        this.settingsKey = (_a = options.settingsKey) !== null && _a !== void 0 ? _a : undefined;
        this.attr = (_b = options.attr) !== null && _b !== void 0 ? _b : undefined;
        this.productCode = (_c = options.productCode) !== null && _c !== void 0 ? _c : undefined;
        this.paperCode = (_d = options.paperCode) !== null && _d !== void 0 ? _d : undefined;
    }
    buildApiUrl(options) {
        let url = options.apiUrl;
        if (url && options.clientCode) {
            url = url.replace(/\[clientCode\]/gi, options.clientCode.toLowerCase());
        }
        return url.endsWith('/') ? url : url + '/';
    }
    buildResourceUrl(options) {
        if (!options.resourceUrl)
            return null;
        let url = options.resourceUrl;
        if (!url.endsWith('/')) {
            url += '/';
        }
        if (!url.toLowerCase().endsWith(this.environment.toLowerCase() + '/')) {
            url += this.environment.toLowerCase() + '/';
        }
        return url;
    }
}
